module.exports = __webpack_public_path__ + "img/chevron-left.89bd9974.svg";